<template>
    <panel-template>
        <template #bradcrumbs>
            <ui-breadcrumbs>
                <template #left>
                    &#8226; <a :href="`/vendas/`">Vendas</a>
                    &#8226; <span>Simulação de Proposta</span>
                </template>
            </ui-breadcrumbs>
        </template>
        <template #content>        
            <div>
                <div v-show="layout.showPage" class="page">
                    <ui-overlay-load v-if="loader.general" />

                    <!-- @start Header da página -->
                    <div class="page-header">
                        <div class="page-header-title">
                            <div class="icon">
                                <i class="fal fa-calculator"/>
                            </div>
                            <div>
                                <div class="title">Simulação de Proposta</div>
                                <div class="subtitle">Informe as condições de pagamento de seu cliente e submeta para aprovação.</div>
                            </div>
                        </div>
                        <div class="info">
                            <div v-if="simulation.created_at"><strong>Criação da Simulação:&nbsp;</strong>{{simulation.created_at | moment("DD [de] MMMM [de] YYYY [às] H:mm")}} </div>
                            <div><strong>Última edição:</strong> {{ new Date | moment("DD [de] MMMM [de] YYYY [às] H:mm")}}</div>
                        </div>
                        <div class="buttons">
                            <ui-button
                                :disabled="!isSaveAllowedComputed"
                                design="lg success"
                                @click="saveSimulationHandler">
                                Salvar Simulação <i class="fal fa-long-arrow-right"/>
                            </ui-button>
                            <ui-button
                                :disabled="!isSaveAllowedComputed"
                                design="lg primary"
                                @click="sentSimulationHandler">
                                Enviar como Proposta <i class="fal fa-long-arrow-right"/>
                            </ui-button>
                        </div>
                    </div>
                    <!-- @end Header da página -->

                    <!-- @start Conteúdo central da página -->
                    <div class="page-container">
                        <!-- @start conteúdo pricipal da página -->
                        <div class="page-content">                    
                            <!-- @start Produto/Empreendimento -->
                            <ui-product v-if="layout.showPage" />

                            <!-- @start Simulador -->
                            <ui-simulator />
                        </div>
                        <!-- @end Principal pricipal da página -->

                        <!-- @start Header da página -->
                        <div class="page-aside">
                            <!-- @start Cliente selecionado para a simulação -->
                            <div class="card client">
                                <div class="header">Dados do Cliente</div>
                                <div class="content">
                                    <ui-client-card :client="client" :deal="deal" :load="loader.client" @add="selectClient" @hide="hideClient" @edit="editClient" />
                                </div>
                            </div>
                            <!-- @end Cliente selecionado para a simulação -->

                            <!-- @start Corretor responsável pela simulação -->
                            <div class="card page-aside-broker">
                                <div class="header">Responsável</div>
                                <div class="content">
                                    <ui-broker-card :broker="owner" :load="loader.owner" />
                                </div>
                            </div>
                            <!-- @end Corretor responsável pela simulação -->
                        </div>
                        <!-- @end Header da página -->
                    </div>
                    <!-- @end Conteúdo central da página -->

                    <!-- @start Seção de Análise financeira da página -->
                    <div v-if="simulationConfig && parseInt(simulationConfig.analyze) && $mx_userGroupHasPermission(groupsToCheck, userGroups, permissionAnalysis, user)" class="page-analysis">
                        <div class="title">Análise Financeira</div>
                        <div class="subtitle">Compare a tabela com a simulação e veja a análise detalhada da proposta.</div>

                        <div class="analysis">
                            <ui-comparison />
                        </div>
                    </div>
                    <!-- @end Seção de Análise financeira da página -->
                </div>

                <div class="page -modal" hidden>
                    <div class="page-header"> 
                        <div class="page-header-title">
                            <div class="icon">
                                <i class="fal fa-calculator"/>
                            </div>
                            <div>
                                <div class="title">Simulação de Proposta</div>
                                <div class="subtitle">Informe as condições de pagamento de seu cliente e submeta para aprovação.</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <ui-product-select-modal @selected="productSelectedHandler" />
                <ui-client-select-modal @selected="clientSelectedHandler" />
                <ui-select-origin-modal @selected="clientSelectedHandler" />
            </div>
        </template>
    </panel-template>
</template>

<script>
    import PanelTemplate from '@/templates/page-panel-center'

    import { uiBreadcrumbs, uiOverlayLoad } from '@/components/ui'
    import uiClientCard from '@/components/ui-facilita/sales/client-card'
    import uiBrokerCard from '@/components/ui-facilita/sales/broker-card'
    import { uiSelectOriginModal } from "@/components/ui-facilita/modals"
    import { uiButton } from "@/components/ui/buttons"
    
    import uiProductSelectModal from './components/product-select-modal'
    import uiClientSelectModal from './components/client-select-modal'
    import uiProduct from './components/product'
    import uiSimulator from './components/simulator'
    import uiComparison from './components/comparison'
    
    import { mapGetters } from 'vuex'

    import helpers from '@/mixins/helpers'

    import permissions from '@/mixins/permissions'

    import { storage } from '@/services/storage'

	import { groups, product } from '@/services/axios'

    export default {
        name: 'ui-sales-simulation',

        components: {
            PanelTemplate,
            uiBreadcrumbs,
            uiButton,
            uiProduct,
            uiSimulator,
            uiComparison,
            uiClientCard,
            uiBrokerCard,
            uiProductSelectModal,
            uiClientSelectModal,
            uiOverlayLoad,
            uiSelectOriginModal
        },

        mixins: [helpers, permissions],

        props: {
            id: {
                type: [String, Number],
                required: false,
                default: 0
            }
        },

        data() {
            return {
                permissionAnalysis: null,
                userGroups: [],
                proposalSettings: [],
                layout: {
                    showPage: false,
                    showClientSelectedModal: true,
                },
                loader: {
                    client: false,
                    owner: false,
                    general: false
                }
            }
        },

        computed: {
            ...mapGetters('simulation', {
                client: 'getCustomer',
                deal: 'getCustomerDeal',
                fixedValue: 'getFixedValue',
                owner: 'getSimulationOwner',
                proposedBaseCost: 'getProposedBaseCost',
                proposedFutureValue: 'getProposedFutureValue',
                proposedValue: 'getProposedValue',
                salesTableFlow: 'getSalesTableFlow',
                series: 'getSeries',
                simulationConfig: 'getSimulationConfig',
                unityValueWithDiscount: 'getUnityValueWithDiscount',
                simulation: 'getSimulation',
                stageAllowFill: 'getStageAllowFill',
                product: 'getProduct',
            }),
            /**
             * Computed property que define se é permitido realizar o salvamento e envio da
             * simulação atual
             */
            isSaveAllowedComputed() {
                return this.client && this.stageAllowFill
            },
            groupsToCheck() {
                const proposalSettings = JSON.parse(storage.get('proposal_settings'));
                this.permissionAnalysis = proposalSettings?.simulation?.permission_analysis;
                if (this.simulationConfig?.permission_analysis && parseInt(this.simulationConfig.configurations) == 1) {
                    this.permissionAnalysis = this.simulationConfig.permission_analysis;
                }
                
                if (!this.permissionAnalysis) return [];
                
                if (this.product.infos.simulation?.groups_analysis?.length > 0) {
                    return this.product.infos.simulation?.groups_analysis;
                }

                if (proposalSettings?.simulation?.groups_analysis?.length > 0) {
                    return proposalSettings.simulation.groups_analysis;
                }

                return [];
            }
        },

        mounted() {
            /** Pega os dados do usuário logado no state do módulo vuex de autenticação */
            const user = { ...this.$store.state.auth.user }

		
            groups.getGroups().then((response) => {
                this.userGroups = response.data.map((group) =>{
                    return { group_id: group.id, group_name: group.name }
                })
            })
          
            /**
             * Chama a action que verifica se uma simulação foi iniciada a partir da página
             * de detalhes de uma unidade
             */
           
             this.$store.dispatch('simulation/checkUnitySimulation', {'payload':user, 'deal_id':this.id})
             .then(() => {
                    this.$set(this.layout, 'showPage', true) 
                    this.$store.dispatch('simulation/fetchStageAllowFill')

                })
                .catch((error) => {

                    this.$store.dispatch('simulation/fetchStageAllowFill')

                    /** Verifica se um negócio foi passado como parâmetro e, portanto, é a edição de uma simulação */            
                    if (!error) {
                        this.$root.$emit("modal-open-simulation-product", { hideCancel: true });
                        return;
                    }
                      //Caso não haja produto na interna do negócio
                      if(error.noProduct) {
                        this.$root.$emit('modal-open-simulation-product', { hideCancel: true });
                        return;
                    }
                    /** Verifica se um negócio foi passado como parâmetro e, portanto, é a edição de uma simulação */
                    /** Se retornar um id de simulação vindo da action da store, significa que há uma simulação e renderiza a tela, caso não, renderiza o modal de seleção de produto */
                    /** Esse caso ocorre quando há tentativa de fazer simulação pra um cliente sem produto */

                    if(!error?.simulation_id){
                         this.$root.$emit('modal-open-simulation-product', { hideCancel: true });
                        return;
                    } 
                    if(error?.productHasChanged){
                        this.$store.dispatch('simulation/removeAllSimulationSeries');
                        if(!error.unity_cost){
                             this.$root.$emit('modal-open-simulation-product', { hideCancel: true });
                            return;
                        } 
                        this.$set(this.layout, 'showPage', true);
                    }
                    if(!error.productHasChanged){

                        this.$set(this.layout, 'showPage', true);
                    }
                })
        },

        beforeDestroy() {
            /**
             * Antes de carregar uma simulação ou iniciar uma nova, limpa os dados da última simulação
             * realizada
             */
            this.$store.dispatch('simulation/clearSimulation')
        },

        methods: {
            /**
             * Handler que trata o evento de quando um produto e unidade são selecionados
             */
            productSelectedHandler(payload) {
                this.$store.dispatch('simulation/setSimulationProduct', payload)
                this.$store.dispatch('simulation/setSimulationUnity', payload)

                this.$nextTick(() => {
                    this.$set(this.layout, 'showPage', true)
                })
            },
            /**
             * Handler que trata o evento de quando um cliente é selecionado
             */
            clientSelectedHandler(payload) {
                this.$set(this.loader, 'client', true)

                setTimeout(() => {
                    this.$store.dispatch('simulation/setCustomer', payload.client)
                    this.$store.dispatch('simulation/setCustomerDeal', payload.deal)
                    /** Verifica se o negócio possui um responsável e o configura para a simulação */
                    if (payload.deal && payload.deal.owners) {
                        this.$store.dispatch('simulation/setSimulationOwner', payload.deal.owners)

                    } else if (payload.client) {
                        this.$store.dispatch('simulation/setSimulationOwner', payload.client.owners)
                    }

                    /**  Atualiza o stageAllowFill do Vuex */
                    this.$store.commit('simulation/SET_STAGE_ALLOW_FILL', null)
                    this.$store.dispatch('simulation/fetchStageAllowFill')

                    setTimeout(() => {
                        this.$set(this.loader, 'client', false)
                    }, 404)
                }, 809)
            },

            /**
             * Evento dispara ao clicar no botão de adicionar cliente
             */
            selectClient() {
                this.$root.$emit('modal-open-simulation-client')
            },

            /**
             * Evento dispara ao clicar no botão de fechar o cartão do cliente
             * Deve limpar o conteúdo do cliente
             */
            hideClient() {
                this.$set(this.loader, 'client', true)
                setTimeout(() => {
                    this.$store.dispatch('simulation/setCustomer', null)
                    this.$store.dispatch('simulation/setCustomerDeal', null)
                    this.$store.dispatch('simulation/setSimulationOwner', null)
                    this.$set(this.loader, 'client', false)
                }, 404)
            },

            /**
             * Evento dispara ao clicar no botão de editar o cliente
             */
            editClient() {
                this.$root.$emit('modal-open-simulation-client')
            },

            /**
             * Evento dispara ao fechar o modal de cadastrar o cliente
             */
            addNewClientHandler() {
                this.$set(this.layout, 'showClientSelectedModal', true)
            },

            /**
             * Retorna uma promessa que define o processe de salvamento da simulação atual, e que
             * deve ser tratada posteriormente
             *
             * @param {Boolean} redirect Define se deve redirecionar para a tela de edição
             */
            savePromise(redirect) {
                this.$set(this.loader, 'general', true)
                return new Promise((resolve, reject) => {
                    if (!this.isSaveAllowedComputed) throw new Error('Não é possível salvar a simulação atual. Por favor, verifique o cliente e o negócio selecionados.')
                    this.$store.dispatch('simulation/saveSimulation')
                        .then(response => {
                            this.$toastr.s(response.data.msg)
                            /** Redireciona para a interna do negócio */
                            if (redirect) this.oldPanelLinkButton(`/vendas/negocios/${response.data.data.deal_id}`)

                            resolve(response)
                        })
                        .catch(error => {
                            this.$set(this.loader, 'general', false)
                            if (typeof error === 'string') this.$toastr.e(error)
                            reject(error)
                        })
                })
            },

            /**
             * Chama a action do módulo de simulações que salva a simulação atual e
             * mostra o modal de procedi
             */
            saveSimulationHandler() {
                /**
                 * Emite o evento do Google Analytics
                 */
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: "vuejs-simular proposta",
                    action: "click",
                    label: "Botão salvar proposta",
                })

                this.savePromise(true).catch(error => {
                    if (error && error.data && error.data.msg) {
                        this.$toastr.e(error.data.msg)

                    } else if (error && error.message) {
                        this.$toastr.e(error.message)
                    }
                    console.error(error)
                })
            },

            /**
             * Define o localStorage e envia para guia de simulação/proposta
             */
            sentSimulationHandler() {
                /**
                 * Emite o evento do Google Analytics
                 */
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: "vuejs-simular proposta",
                    action: "click",
                    label: "Botão enviar como proposta",
                })

                this.savePromise(false)
                    .then(() => {
                        storage.set('data_client', JSON.stringify(this.client))
                        storage.set('data_deal', JSON.stringify(this.deal))

                        this.oldPanelLinkButton("guia/simulationNew/1")
                    })
                    .catch(error => {
                        if (error && error.data && error.data.msg) {
                            this.$toastr.e(error.data.msg)

                        } else if (error && error.message) {
                            this.$toastr.e(error.message)
                        }
                        console.log(error)
                    })
            },

            /**
             * Evento disparado ao clicar no botão de salvar simulação
             * Mostra o modal de PROCEDIMENTOS
             */
            showProcedures() {
                this.$root.$emit('modal-open-sales-procedure')
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>